<template>
    <!-- Modal -->
    <b-modal id="osInterna" :title="$t('Informações sobre OS') + ': ' + (this.os ? this.os.nr_sequencial : '')" size="lg">
        <div class="container" v-if="os">
            <div class="row">
                <div class="form-group col-lg-4 col-md-4">
                    <span class="font-weight-bold">{{ $t('Data OS') }}</span><br />
                    <span class="text-lg ">
                        {{ os.dt_os | formatDate("DD/MM/YYYY HH:mm:ss") }}
                    </span>
                </div>
                <div class="form-group col-lg-3 col-md-3">
                    <span class="font-weight-bold">{{ $t('Placa') }}</span><br />
                    <span class="text-lg ">
                        {{ os.nr_placa }}
                    </span>
                </div>
                <div class="form-group col-lg-4 col-md-4">
                    <span class="font-weight-bold">{{ $t('KM') }}</span><br />
                    <span class="text-lg ">
                        {{ os.km_atual }}
                    </span>
                </div>
                <div class="form-group col-lg-4 col-md-4">
                    <span class="font-weight-bold">{{ $t('Data Inicial') }}</span><br />
                    <span class="text-lg ">
                        {{ os.dt_inicial | formatDate("DD/MM/YYYY HH:mm:ss") }}
                    </span>
                </div>
                <div class="form-group col-lg-4 col-md-4">
                    <span class="font-weight-bold">{{ $t('Data Final') }}</span><br />
                    <span class="text-lg ">
                        {{ os.dt_final | formatDate("DD/MM/YYYY HH:mm:ss") }}
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-lg-12 col-md-12">
                    <span class="font-weight-bold">{{ $t('Observacao') }}</span><br />
                    <span class="text-lg ">
                        {{ os.ds_observacao }}
                    </span>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="form-group col-lg-12 col-md-12">
                    <span class="font-weight-bold">{{ $t('Itens:') }}</span><br />


                    <span class="text-lg form-control col-12" 
                        v-for="(item, index) in os.items" :key="index">
                        <strong>{{ item.item_geral.nr_seq_tipoitem == 3 ? $t('SERVIÇO') : $t('PEÇA') }}</strong> - {{ item.item_geral.ds_item.substring(0, 35) }} - {{ item.execucoes && item.execucoes[0] ?
                                                     item.execucoes[0].tecnico_inicio.ds_colaborador.substring(0, 10) : $t('Sem execução')  }}
                    </span>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>

export default {
  props: {
    os: {}
  },
}
</script>